import { IP360PartnerFlags } from 'partner360/models/p360PartnerFlags/IP360PartnerFlags'

import { IPreparedTopPartner } from '../models'

import { hasFlag } from './hasFlag'

export type TFlagRequestDirection = 'added' | 'removed' | null

export const getFlagRequestDirection = (
  partner: IPreparedTopPartner,
  flag: IP360PartnerFlags
): TFlagRequestDirection => {
  const requested = partner.ParsedRequest?.[flag.FlagKey]

  if (requested === undefined) {
    return null
  }

  const isFlagged = Number(hasFlag(partner.BitClass, flag.BitValue))

  if (requested === isFlagged) {
    return null
  }

  return requested === 1 ? 'added' : 'removed'
}
